/**
 * Learn-once flag for the OperationBar just-in-time callout (the coachmark that
 * teaches the bottom progress bar + its expand/cancel affordance the first time
 * an operation runs). Per-user, permanent. Pure module so it's testable with
 * `localStorage.clear()` — mirrors lib/guidedRun.ts.
 */

function key(authId: string): string {
  return `paperchase-opbar-callout-seen-${authId}`;
}

export function isOpBarCalloutSeen(authId: string): boolean {
  try {
    return localStorage.getItem(key(authId)) === "1";
  } catch {
    // Safari private mode etc. — treat as seen (never nag) is wrong here;
    // treat as not-seen so the callout can still try, but writes will no-op.
    return false;
  }
}

export function markOpBarCalloutSeen(authId: string): void {
  try {
    localStorage.setItem(key(authId), "1");
  } catch {
    // ignore — private mode
  }
}
